import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SiteFooter } from "@/pages/Legal";
import { HomeTopNav, HeroCopy, HomeCards, StatsBar, ServicesBand } from "@/components/HomeParts";

const HERO = "/brand/hero-laser-head.webp";

export default function Home() {
  const { user } = useAuth();
  const { data: stats } = useQuery({ queryKey: ["stats", !!user], queryFn: async () => (await api.get("/stats")).data });
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200">
      <section className="relative overflow-hidden border-b border-slate-800">
        <img src={HERO} alt="FLS CO2 laser head over the cutting bed" className="absolute inset-0 h-full w-full origin-left scale-[1.35] object-cover opacity-55" data-testid="home-hero-image" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/85 to-slate-950/20" />
        <div className="absolute inset-0 grid-bg" />
        <HomeTopNav user={user} />
        <HeroCopy />
      </section>
      <section className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <StatsBar stats={stats} />
        <HomeCards />
      </section>
      <ServicesBand />
      <SiteFooter />
    </div>
  );
}
